<template>
    <section class="main-img-section _preview-section">
        <div class="section-inner">
            <div class="main-img-item-wrap">

                <swiper class="swiper-container _main-image"
                    :navigation='{
                        "prevEl": ".swiper-btn-wrap._main-image .js-swiper-prev",
                        "nextEl": ".swiper-btn-wrap._main-image .js-swiper-next"
                    } '
                    :breakpoints='{
                        "800": {
                            "slidesPerView": 2,
                            "spaceBetween": 26
                        },
                    } '
                    :slides-per-view="1"
                    :space-between="0"
                    :speed="500"
                    :autoplay='{
                        "delay": 2000,
                        "disableOnInteraction": false
                    }'
                >

                    <swiper-slide v-for="(data, key, index) in mainImages" v-bind:key="index">
                        <div class="main-img-item form_file-img md_no-image">
                            <img class="preview" v-bind:class="'_main-img' + key">
                            <img v-if="data" v-bind:src="data" alt="">
                        </div>
                    </swiper-slide>

                </swiper>

            </div>
        </div>
    </section>
</template>

<script>

    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"

    //SwiperModules
    import SwiperCore, {
        Autoplay,
        Pagination,
        Navigation
    } from 'swiper';
    SwiperCore.use([
        Autoplay,
        Pagination,
        Navigation
    ]);

    //Svg
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    export default {
        components: {
            SvgIconImagePlace,
            //Swiper.js
            Swiper,
            SwiperSlide,
        },
        props: {
            mainImages: Object,
        },

    }
</script>

